import React, { FC } from 'react';
import { CustomColumn } from '../../../../types/components/tables/tableTypes';
import { addCommasToNumbersAndRound } from '../../../../utilities/numberFormatters';
import GridItem from '../../../layout/GridComponents/GridItem';
import CustomTable from '../../../tables/CustomTable';

interface MancoCounterpartySummaryTableProps {
  data: any;
  isFetching: boolean;
}

interface MancoSummaryTableData {
  name: string;
  value: string;
}

function buildMancoSummaryTableData(data: any): MancoSummaryTableData[] {
  if (!data) return [];
  const tableData: MancoSummaryTableData[] = [
    {
      name: 'Position Dates',
      value: data.selected_position_date,
    },
    {
      name: 'Base Currency',
      value: data.base_currency,
    },
    {
      name: 'Net Exposure',
      value: addCommasToNumbersAndRound(data.total_net_exposure),
    },
    {
      name: 'Gross Exposure',
      value: addCommasToNumbersAndRound(data.total_gross_exposure),
    },
    {
      name: 'Cash Exposure',
      value: addCommasToNumbersAndRound(data.asset_class_bc_exposure?.cash || 0),
    },
    {
      name: 'Derivative Cash Exposure',
      value: addCommasToNumbersAndRound(
        data.asset_class_derivative_gross_exposure?.cash || 0,
      ),
    },
    {
      name: 'Unrealised P/L',
      value: addCommasToNumbersAndRound(data.total_unrealised_pl),
    },
    {
      name: 'Collateral',
      value: addCommasToNumbersAndRound(data.total_bc_collateral),
    },
  ];
  return tableData;
}

const tableColumns: CustomColumn<MancoSummaryTableData>[] = [
  {
    title: 'Data',
    field: 'name',
    width: '75%',
    cellStyle: {
      textAlign: 'left',
    },
    headerStyle: {
      textAlign: 'left',
    },
  },
  {
    title: 'Field',
    field: 'value',

    cellStyle: {
      textAlign: 'right',
    },
    headerStyle: {
      textAlign: 'center',
    },
  },
];

const MancoCounterpartySummaryTable: FC<MancoCounterpartySummaryTableProps> = (
  props,
) => {
  const { data, isFetching } = props;
  const tableData = buildMancoSummaryTableData(data);

  return (
    <GridItem card xs={3} cardStyle={{ height: '100%' }}>
      <CustomTable<MancoSummaryTableData>
        id="manco_agg_static_exposure"
        title={'Aggregate Static Exposure'}
        showToolbar={true}
        multipleTablePdfParameters={{
          specifiedWidth: 4,
          tablesInRow: 3,
        }}
        loading={isFetching}
        columns={tableColumns}
        data={tableData}
        options={{
          paging: false,
          search: false,
          header: false,
          exportButton: true,
        }}
      />
    </GridItem>
  );
};

export default MancoCounterpartySummaryTable;
